<template>
  <div class="act-repurchase-root" :class="{ 'ar-style': $i18n.locale === 'ar' }">
    <div class="custom-nav-block" :class="packageName" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb" @click-right="toggleShowRules(true)">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
        </template>
        <template #right>
          <div class="right-tips">{{ $t('lang.call.tit1') }}</div>
        </template>
      </van-nav-bar>
    </div>

    <div class="repurchase-content" :style="`margin-top:-${barHeight + 46}px`">
      <!-- 多包相关 -->
      <img v-if="packageName === 'echo'" class="banner-img" src="./images/bg-2.png" />
      <img v-else class="banner-img" src="./images/bg-1.png" />

      <div class="main-table" :style="`margin-top:-${barHeight + 262}px`">
        <div class="main-tit1">{{ $t('lang.commonM.k143') }}</div>
        <div class="main-tit2">
          <MyPLabel :str="$t('lang.commonM.k144')" :customClass="{ coin: 'repurchase-tit-coin' }" />
        </div>

        <div class="main-timer-block">
          <div v-if="displayTime" class="main-timer">
            <img src="./images/clock.png" />
            {{ $t('lang.commonM.k145') }}
            <span>{{ displayTime.days }}</span>
            :
            <span>{{ displayTime.hours }}</span>
            :
            <span>{{ displayTime.minutes }}</span>
            :
            <span>{{ displayTime.seconds }}</span>
          </div>
        </div>

        <div class="reward-block" v-if="baseInfo && baseInfo.taskProc && baseInfo.taskProc[0]">
          <div class="reward-head">
            <img src="./images/star.png" />
            <span>{{ $t('lang.intimate.reward') }} 1</span>
            <img src="./images/star.png" />
          </div>
          <div class="percent-tips">
            <i>{{ baseInfo.taskProc[0].proc }}</i>
            /{{ baseInfo.taskProc[0].target }}
            <img :src="getMatchImg('coin')" />
          </div>
          <div class="percent-bar">
            <div class="percent-track" :style="{ width: `${baseInfo.taskProc[0].percent}%` }"></div>
          </div>
          <div class="gifts" style="gap: 10px">
            <div>
              <img :src="getMatchImg('coins')" alt="" />
              <div v-if="baseInfo.taskProc[0].rewards" class="rewards-count">x{{ baseInfo.taskProc[0].rewards[0].number || 0 }}</div>
            </div>
            <div>
              <img :src="getMatchImg('coupon')" alt="" />
              <div v-if="baseInfo.taskProc[0].rewards" class="rewards-count">x{{ baseInfo.taskProc[0].rewards[1].number || 0 }}</div>
            </div>
            <div>
              <img :src="getMatchImg('video-pass')" alt="" />
              <div v-if="baseInfo.taskProc[0].rewards" class="rewards-count">x{{ baseInfo.taskProc[0].rewards[2].number || 0 }}</div>
            </div>
            <div>
              <img :src="getMatchImg('super-chat-pass')" alt="" />
              <div v-if="baseInfo.taskProc[0].rewards" class="rewards-count">x{{ baseInfo.taskProc[0].rewards[3].number || 0 }}</div>
            </div>
          </div>

          <template v-if="baseInfo.taskProc[0].ifDone === false">
            <div class="claim-btn off-btn">{{ $t('lang.commonM.k073') }}</div>
          </template>

          <template v-if="baseInfo.taskProc[0].ifDone === true">
            <div v-if="baseInfo.taskProc[0].ifClaimed === false" class="claim-btn" @click="handleClaim(baseInfo.taskProc[0], 0)">{{ $t('lang.commonM.k073') }}</div>
            <div v-else class="claim-btn off-btn">{{ $t('lang.commonM.k074') }}</div>
          </template>
        </div>

        <div class="reward-block" v-if="baseInfo && baseInfo.taskProc && baseInfo.taskProc[1]">
          <div class="reward-head">
            <img src="./images/star.png" />
            <span>{{ $t('lang.intimate.reward') }} 2</span>
            <img src="./images/star.png" />
          </div>
          <!-- prettier-ignore -->
          <div class="percent-tips">
            <i>{{ baseInfo.taskProc[1].proc }}</i>/{{ baseInfo.taskProc[1].target }}
            <img :src="getMatchImg('coin')" />
          </div>
          <div class="percent-bar">
            <div class="percent-track" :style="{ width: `${baseInfo.taskProc[1].percent}%` }"></div>
          </div>
          <div class="gifts" style="gap: 10px">
            <div>
              <img :src="getMatchImg('coins')" alt="" />
              <div v-if="baseInfo.taskProc[1].rewards" class="rewards-count">x{{ baseInfo.taskProc[1].rewards[0].number || 0 }}</div>
            </div>
            <div>
              <img :src="getMatchImg('video-pass')" alt="" />
              <div v-if="baseInfo.taskProc[1].rewards" class="rewards-count">x{{ baseInfo.taskProc[1].rewards[1].number || 0 }}</div>
            </div>
            <div>
              <img :src="getMatchImg('super-chat-pass')" alt="" />
              <div v-if="baseInfo.taskProc[1].rewards" class="rewards-count">x{{ baseInfo.taskProc[1].rewards[2].number || 0 }}</div>
            </div>
          </div>

          <template v-if="baseInfo.taskProc[1].ifDone === false">
            <div class="claim-btn off-btn">{{ $t('lang.commonM.k073') }}</div>
          </template>

          <template v-if="baseInfo.taskProc[1].ifDone === true">
            <div v-if="baseInfo.taskProc[1].ifClaimed === false" class="claim-btn" @click="handleClaim(baseInfo.taskProc[1], 1)">{{ $t('lang.commonM.k073') }}</div>
            <div v-else class="claim-btn off-btn">{{ $t('lang.commonM.k074') }}</div>
          </template>
        </div>

        <div class="reward-block" v-if="baseInfo && baseInfo.taskProc && baseInfo.taskProc[2]">
          <div class="reward-head">
            <img src="./images/star.png" />
            <span>{{ $t('lang.intimate.reward') }} 3</span>
            <img src="./images/star.png" />
          </div>
          <div class="percent-tips">
            <i>{{ baseInfo.taskProc[2].proc }}</i>
            /{{ baseInfo.taskProc[2].target }}
            <img :src="getMatchImg('coin')" />
          </div>
          <div class="percent-bar">
            <div class="percent-track" :style="{ width: `${baseInfo.taskProc[2].percent}%` }"></div>
          </div>
          <div class="gifts" style="gap: 10px">
            <div>
              <img :src="getMatchImg('coins')" alt="" />
              <div v-if="baseInfo.taskProc[2].rewards" class="rewards-count">x{{ baseInfo.taskProc[2].rewards[0].number || 0 }}</div>
            </div>
            <div>
              <img :src="getMatchImg('video-pass')" alt="" />
              <div v-if="baseInfo.taskProc[2].rewards" class="rewards-count">x{{ baseInfo.taskProc[2].rewards[1].number || 0 }}</div>
            </div>
            <div>
              <img :src="getMatchImg('super-chat-pass')" alt="" />
              <div v-if="baseInfo.taskProc[2].rewards" class="rewards-count">x{{ baseInfo.taskProc[2].rewards[2].number || 0 }}</div>
            </div>
          </div>

          <template v-if="baseInfo.taskProc[2].ifDone === false">
            <div class="claim-btn off-btn">{{ $t('lang.commonM.k073') }}</div>
          </template>

          <template v-if="baseInfo.taskProc[2].ifDone === true">
            <div v-if="baseInfo.taskProc[2].ifClaimed === false" class="claim-btn" @click="handleClaim(baseInfo.taskProc[2], 2)">{{ $t('lang.commonM.k073') }}</div>
            <div v-else class="claim-btn off-btn">{{ $t('lang.commonM.k074') }}</div>
          </template>
        </div>

        <div class="still-block"></div>
        <div v-if="baseInfo && baseInfo.ifValid" class="top-up-block">
          <div class="top-up-btn" @click="handleTopUp">
            <img src="./images/star.png" />
            <span>{{ $t('lang.commonM.k146') }}</span>
            <img src="./images/star.png" />
          </div>
          <div :style="{ height: `${bottomBarHeight}px` }"></div>
        </div>
      </div>
    </div>

    <div v-if="showSuccess" class="act-mask">
      <div class="con-block" v-if="successIndex === 0">
        <div class="gifts-blank">{{ $t('lang.commonM.k147') }}</div>
        <div class="gifts" v-if="baseInfo && baseInfo.taskProc && baseInfo.taskProc[0].rewards">
          <div>
            <img :src="getMatchImg('coins')" alt="" />
            <div class="rewards-count">x{{ baseInfo.taskProc[0].rewards[0].number }}</div>
          </div>
          <div>
            <img :src="getMatchImg('coupon')" alt="" />
            <div class="rewards-count">x{{ baseInfo.taskProc[0].rewards[1].number }}</div>
          </div>
        </div>
        <div class="gifts">
          <div>
            <img :src="getMatchImg('video-pass')" alt="" />
            <div class="rewards-count">x{{ baseInfo.taskProc[0].rewards[2].number }}</div>
          </div>
          <div>
            <img :src="getMatchImg('super-chat-pass')" alt="" />
            <div class="rewards-count">x{{ baseInfo.taskProc[0].rewards[3].number }}</div>
          </div>
        </div>
        <div class="rules-confirm">
          <div @click="showSuccess = false">{{ $t('lang.ok') }}</div>
        </div>
      </div>

      <div class="con-block" v-if="successIndex === 1">
        <div class="gifts-blank">{{ $t('lang.commonM.k147') }}</div>
        <div class="gifts" v-if="baseInfo && baseInfo.taskProc && baseInfo.taskProc[1].rewards">
          <div>
            <img :src="getMatchImg('coins')" alt="" />
            <div class="rewards-count">x{{ baseInfo.taskProc[1].rewards[0].number }}</div>
          </div>
          <div>
            <img :src="getMatchImg('video-pass')" alt="" />
            <div class="rewards-count">x{{ baseInfo.taskProc[1].rewards[1].number }}</div>
          </div>
          <div>
            <img :src="getMatchImg('super-chat-pass')" alt="" />
            <div class="rewards-count">x{{ baseInfo.taskProc[1].rewards[2].number }}</div>
          </div>
        </div>
        <div class="rules-confirm">
          <div @click="showSuccess = false">{{ $t('lang.ok') }}</div>
        </div>
      </div>

      <div class="con-block" v-if="successIndex === 2">
        <div class="gifts-blank">{{ $t('lang.commonM.k147') }}</div>
        <div class="gifts" v-if="baseInfo && baseInfo.taskProc && baseInfo.taskProc[2].rewards">
          <div>
            <img :src="getMatchImg('coins')" alt="" />
            <div class="rewards-count">x{{ baseInfo.taskProc[2].rewards[0].number }}</div>
          </div>
          <div>
            <img :src="getMatchImg('video-pass')" alt="" />
            <div class="rewards-count">x{{ baseInfo.taskProc[2].rewards[1].number }}</div>
          </div>
          <div>
            <img :src="getMatchImg('super-chat-pass')" alt="" />
            <div class="rewards-count">x{{ baseInfo.taskProc[2].rewards[2].number }}</div>
          </div>
        </div>
        <div class="rules-confirm">
          <div @click="showSuccess = false">{{ $t('lang.ok') }}</div>
        </div>
      </div>
    </div>

    <div v-if="showRules" class="act-mask">
      <div class="act-rules">
        <div class="reward-head">
          <img src="./images/star.png" />
          <span>{{ $t('lang.commonM.k111') }}</span>
          <img src="./images/star.png" />
        </div>
        <div class="act-rules-item">
          <span>1.</span>
          <p>{{ $t('lang.commonM.k148') }}</p>
        </div>
        <div class="act-rules-item">
          <span>2.</span>
          <p>{{ $t('lang.commonM.k149') }}</p>
        </div>
        <div class="act-rules-item">
          <span>3.</span>
          <p>{{ $t('lang.commonM.k150') }}</p>
        </div>
        <div class="rules-confirm">
          <div @click="toggleShowRules(false)">{{ $t('lang.commonM.k112') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repurchaseActCfg, repurchaseActClaim } from './apidir/api.js'

export default {
  data() {
    return {
      displayTime: {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
      },
      lastTime: 0,
      endTime: 0,
      showRules: false,
      baseInfo: null,
      showSuccess: false,
      successIndex: -1
    }
  },
  methods: {
    startCountdown() {
      const countdownFn = (currentTime) => {
        // 避免过于频繁的更新
        if (currentTime - this.lastTime >= 1000) {
          const remainingTime = this.endTime - Date.now()

          if (remainingTime <= 0) {
            this.displayTime = {
              days: '00',
              hours: '00',
              minutes: '00',
              seconds: '00'
            }
            this.refreshData()
            return
          }

          this.displayTime = this.formatTime(remainingTime)
          this.lastTime = currentTime
        }

        // 继续下一帧
        this.animationFrameId = requestAnimationFrame(countdownFn)
      }

      this.animationFrameId = requestAnimationFrame(countdownFn)
    },
    // 格式化时间显示
    formatTime(ms) {
      if (ms <= 0) {
        return {
          days: '00',
          hours: '00',
          minutes: '00',
          seconds: '00'
        }
      }

      let totalSeconds = ms / 1000
      let lastSec = 0

      const days = Math.floor(totalSeconds / 86400)
      lastSec = totalSeconds % 86400

      const hours = Math.floor(lastSec / 3600)
      lastSec = lastSec % 3600

      const minutes = Math.floor(lastSec / 60)
      const seconds = Math.floor(lastSec % 60)

      return {
        days: String(days).padStart(2, '0'),
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0')
      }
    },
    toggleShowRules(arg) {
      this.showRules = arg
    },
    getBaseInfo() {
      repurchaseActCfg().then((resData) => {
        if (resData && !resData.error) {
          if (resData.taskProc) {
            resData.taskProc.forEach((task) => {
              task.percent = (task.proc / task.target).toFixed(2) * 100
            })
          }
          this.baseInfo = resData || null

          // 初始化倒计时
          try {
            if (resData.expireSeconds) {
              let now = Date.now()
              this.endTime = now + resData.expireSeconds * 1000
              this.startCountdown(now)
            }
          } catch (err) {
            this.showTime = {
              days: '',
              hours: '',
              minutes: '',
              seconds: ''
            }
          }
        }
      })
    },
    handleClaim(argObj, index) {
      if (!argObj.cfgId) {
        return
      }
      repurchaseActClaim(argObj.cfgId).then((res) => {
        if (res) {
          this.successIndex = index
          this.showSuccess = true
          this.getBaseInfo()
        }
      })
    },
    // 多包相关
    handleTopUp() {
      if (this.packageName === 'echo') {
        this.$router.push({ path: '/echo-pay-store' })
      }
      //
      else {
        this.$router.push({ path: '/buy-coins' })
      }
    },
    refreshData() {
      if (this.baseInfo) {
        this.baseInfo.ifValid = false
      }
    }
  },
  created() {
    this.getBaseInfo()
  }
}
</script>
<style lang="scss" scoped>
.act-repurchase-root {
  width: 100%;
  min-height: 100vh;
  background: #ffdd29;

  .custom-nav-block {
    .van-nav-bar {
      .van-nav-bar__content {
        .van-nav-bar__right {
          padding: 0;
          &:active {
            opacity: 1 !important;
          }

          .right-tips {
            min-width: 62px;
            height: 28px;
            padding: 0 10px;
            display: inline-flex;
            justify-content: center;
            align-items: center;

            border-radius: 20px;
            background: #feec8a;

            color: #936418;
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }
        }
      }
    }
  }

  // 多包相关
  .custom-nav-block.vava {
    background: url(./images/bg-1.png) left top / 100% auto no-repeat;
  }
  .custom-nav-block.echo {
    background: url(./images/bg-2.png) left top / 100% auto no-repeat;
  }
  .custom-nav-block.joychat {
    background: url(./images/bg-1.png) left top / 100% auto no-repeat;
  }
  .custom-nav-block.kiko {
    background: url(./images/bg-1.png) left top / 100% auto no-repeat;
  }

  .repurchase-content {
    position: relative;
    background: #ffdd29;
    .banner-img {
      width: 100%;
    }

    .main-table {
      width: 100%;
      padding-bottom: 60px;
      padding-top: 15px;
      position: relative;
      .main-tit1 {
        color: #643419;
        font-family: Poppins;
        font-size: 18px;
        font-style: italic;
        font-weight: 600;
        line-height: 27px;
        text-indent: 20px;
      }

      .main-tit2 {
        color: #643419;
        text-shadow: 2px 1px 0 #ebc63c;
        font-family: Poppins;
        font-size: 36px;
        font-style: italic;
        font-weight: 700;
        line-height: 54px;
        text-indent: 20px;
      }

      .main-timer-block {
        width: 100%;
        text-align: center;
        .main-timer {
          display: inline-block;
          padding: 0 20px;
          line-height: 38px;
          margin: 99px auto 12px;
          position: relative;
          text-indent: 60px;
          background: url(./images/rect-block.png) center center / 100% 100% no-repeat;
          color: #fcfaea;
          font-family: Poppins;
          font-size: 16px;
          font-weight: 600;
          img {
            width: 48px;
            height: 48px;
            position: absolute;
            left: 12px;
            bottom: 0;
          }

          span {
            display: inline-block;
            vertical-align: baseline;
            min-width: 28px;
            max-width: 48px;
            height: 26px;
            line-height: 26px;
            margin: 0 2px;
            border-radius: 4px;
            background: rgba(100, 52, 25, 0.6);
            color: #ffd53d;
            font-family: Poppins;
            font-size: 16px;
            font-style: italic;
            font-weight: 700;
            text-indent: 0;
            text-align: center;
          }
        }
      }

      .reward-block {
        width: 335px;
        height: 303px;
        margin: 0 auto 20px;
        border-radius: 16px;
        border: 1px solid #fff;
        background: #fcfaea;
        .reward-head {
          width: 335px;
          line-height: 58px;
          background: linear-gradient(0deg, #fff4df 0%, #ffea9f 100%);
          border-top-left-radius: 16px;
          border-top-right-radius: 16px;
          text-align: center;

          img {
            width: 12px;
            height: 14px;
          }
          span {
            color: #936418;
            text-align: center;
            font-family: Poppins;
            font-size: 18px;
            font-weight: 600;
            margin: 0 15px;
          }
        }
        .percent-tips {
          width: 100%;
          color: #a39682;
          font-family: Poppins;
          font-size: 14px;
          font-weight: 500;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding: 0 24px;
          margin-top: 20px;
          i {
            color: #fdca0f;
          }
          img {
            width: 18px;
            height: 18px;
            margin: 0 2px;
          }
        }
        .percent-bar {
          width: 287px;
          height: 7px;
          margin: 9px auto 0;
          border-radius: 10px;
          background: #f6e1c3;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .percent-track {
            width: 0;
            height: 7px;
            border-radius: 10px;
            background: #fdc910;
          }
        }
        .gifts {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 20px;
          margin-top: 32px;
          & > div {
            width: 68px;
            height: 68px;
            border-radius: 10px;
            background: #fff6c5;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 4px;
            img {
              width: 33px;
              height: 33px;
              object-fit: contain;
            }
            .reward-count {
              color: #936418;
              text-align: center;
              font-family: Poppins;
              font-size: 13px;
              font-weight: 500;
              text-align: center;
            }
          }
        }
        .claim-btn {
          width: 145px;
          margin: 28px auto 0;
          display: flex;
          padding: 8px 49px 8px 50px;
          justify-content: center;
          align-items: center;
          border-radius: 20px;
          background: #fdc910;

          color: #fff;
          text-align: center;
          font-family: Poppins;
          font-size: 15px;
          font-weight: 600;

          &.off-btn {
            background: rgba(204, 204, 204, 0.8);
          }
        }
      }
      .still-block {
        width: 100%;
        height: 105px;
      }
      .top-up-block {
        width: 100%;
        padding: 15px 0 20px;
        position: fixed;
        background-color: #ffdd29;
        bottom: 0;
        left: 0;

        .top-up-btn {
          width: 287px;
          height: 48px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;

          border-radius: 30px;
          background: #fcfaea;

          color: #643419;
          font-family: Poppins;
          font-size: 16px;
          font-weight: 600;
          img {
            width: 12px;
            height: 14px;
          }

          span {
            margin: 0 16px;
          }
        }
      }
    }
  }

  .act-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;

    .rules-confirm {
      width: 100%;
      text-align: center;
      margin-top: 28px;
      div {
        display: inline-flex;
        padding: 12px 76px;
        justify-content: center;
        align-items: center;
        border-radius: 24px;
        background: #fdc910;

        color: #fff;
        text-align: center;
        font-family: Poppins;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
      }
    }

    .act-rules {
      width: 327px;
      padding-bottom: 30px;
      border-radius: 16px;
      border: 1px solid #fff;
      background: #fcfaea;

      .reward-head {
        width: 327px;
        line-height: 58px;
        background: linear-gradient(0deg, #fff4df 0%, #ffea9f 100%);
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        text-align: center;

        img {
          width: 12px;
          height: 14px;
        }
        span {
          color: #936418;
          text-align: center;
          font-family: Poppins;
          font-size: 18px;
          font-weight: 600;
          margin: 0 15px;
        }
      }

      .act-rules-item {
        color: #643419;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        display: flex;
        padding: 20px 20px 0;
        p {
          margin-left: 5px;
        }
      }
    }

    .con-block {
      width: 327px;
      border-radius: 16px;
      border: 5px solid #ffc74b;
      background: linear-gradient(180deg, #fffef3 28.32%, #fff2d0 98.08%);
      padding-top: 55px;
      padding-bottom: 30px;
      position: relative;

      .gifts-blank {
        width: 327px;
        height: 103px;
        line-height: 83px;
        position: absolute;
        left: 0;
        top: -50px;
        z-index: 99;
        background: url(./images/blank.png) center center / 100% 100% no-repeat;

        color: #643419;
        text-align: center;
        font-family: Poppins;
        font-size: 18px;
        font-weight: 600;
      }

      .gifts {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        margin-bottom: 20px;
        & > div {
          width: 80px;
          height: 80px;
          border-radius: 10px;
          background: #fff6c5;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 4px;
          img {
            width: 33px;
            height: 33px;
            object-fit: contain;
          }
          .reward-count {
            color: #936418;
            text-align: center;
            font-family: Poppins;
            font-size: 13px;
            font-weight: 500;
            text-align: center;
          }
        }
      }
      .rules-confirm {
        div {
          width: 231px;
        }
      }
    }
  }
}

.ar-style {
  // 备用
  .repurchase-content {
    .banner-img {
      transform: rotateY(180deg);
    }
    .main-timer-block {
      .main-timer {
        img {
          left: auto;
          right: 12px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.repurchase-tit-coin {
  width: 28px;
  height: 28px;
  margin: 0 7px;
}
</style>
